import React from 'react'

import './TopNav.scss'

import {Link} from 'react-router-dom'
import Dropdown from  '../Dropdown'

import notifications from '../../assets/JsonData/notification.json'

import user_img from '../../assets/images/LINH.jpg'
import user_menu from '../../assets/JsonData/user_menus.json'

import ThemeMenu from '../../components/thememenu'

const curr_user = {
    display_name: 'Phuong Linh',
    image: user_img
}


const renderUserToggle = (user) => (
    <div className="topnav__right-user">
        <div className="topnav__right-user__image">
            <img src={user.image} alt="UserImage" />
        </div>
        <div className="topnav__right-user__name">
            {user.display_name}
        </div>
    </div>
)

const renderNotificationItem = (item,index) => (
    <div className="notification-item" key={index}>
        <i className={item.icon}></i>
        <span>{item.content}</span>
    </div>
)

const renderUserMenu = (item,index) => (
    <Link to='/' key={index} >
        <div className="notification-item">
            <i className={item.icon}>
                <span>{item.content}</span>
            </i>
        </div>
    </Link>
)



function TopNav() {
    return (
        <div className='topnav'>
            <div className="topnav__search">
                <input type="text" placeholder="Search here ..." />
                <i className="bx bx-search"></i>
            </div>
            <div className="topnav__right">
                <div className="topnav__right-item">
                    <Dropdown className="" 
                        customToggle={() => renderUserToggle(curr_user)}
                        contentData={user_menu}
                        renderItems= {(item,index) => renderUserMenu (item,index)}
                    />
                </div>
                <div className="topnav__right-item">
                    <Dropdown className="" 
                        icon = "bx bx-bell"
                        badge='12'
                        contentData={notifications}
                        renderItems={(item,index) => renderNotificationItem(item, index)}
                        renderFooter={()=>
                            <Link to="/">View All</Link>
                        }
                     />
                </div>
                <div className="topnav__right-item">
                    <ThemeMenu />
                </div>
            </div>
        </div>
    )
}

export default TopNav
